<template>
    <div class="index">
        <div class="top-bg">
            <div class="logo"></div>
            <div class="bg-line"></div>
        </div>
        <div class="project-list">
            <template v-for="(item, index) in projectList" :key="index">
                <div class="project-item" @click="openUrl(item.url)">
                    <div class="project-content">
                        <div class="project-content_title">
                            {{ item.name }}
                        </div>
                        <div class="project-content_subtitle text_overflow">
                            <el-image style="width: 100%; height: 100%" :src="require('@/assets/img/' + item.png + '.png')" fit="contain" />
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="copy-right">
            <div class="foot-content">
                <span>技术支持：北京市运输事业发展中心</span>
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_black">京ICP备05031682号</a>
                <span>京公网安备11010602060056号</span>
            </div>
        </div>
    </div>
</template>
  
<script setup name="indexPage">
import { ref } from 'vue';

const projectList = ref([{
    name: '北京市交通委员会官方网站便民服务栏运输证件信息查询',
    url: 'http://jtw.beijing.gov.cn/bmfw/',
    png: "bmfw"
}, {
    name: '北京市道路运输车辆智能视频监控报警信息系统(政务)',
    url: 'http://yz.jtw.beijing.gov.cn/ivas/',
    png: 'ivas'
}, {
    name: '北京市道路运输车辆智能视频监控报警信息系统(平台)',
    url: 'http://yz.jtw.beijing.gov.cn/ivas-platform/',
    png: 'platform'
}, {
    name: '北京市道路运输车辆智能视频监控报警信息系统(企业)',
    url: 'http://yz.jtw.beijing.gov.cn/ivas-corp/',
    png: 'corp'
}, {
    name: '道路运输车辆动态信息公共服务平台',
    url: 'http://yz.jtw.beijing.gov.cn/bjgps/',
    png: 'bjgps'
}, {
    name: '首都核心区旅游客车综合治理信息系统',
    url: 'https://yz.jtw.beijing.gov.cn/hxq/#/login',
    png: 'hxq'
}, {
    name: '北京市包车客运管理系统',
    url: 'https://yz.jtw.beijing.gov.cn/bc/#/login',
    png: 'bc'
}, {
    name: '机动车维修公众服务平台',
    url: 'https://weixiu.bjysgl.cn/bjvmpsf/f/trRptRepairEnterprise',
    png: 'trRptRepairEnterprise'
}, {
    name: '外埠进京客车卫星定位监视系统',
    url: 'http://waibu.bjysgl.cn:8081/',
    png: 'waibu'
}, {
    name: '交通运输行业综合统计平台(已停用)',
    url: '',
    png: 'error'
}, {
    name: '北京市站场接续运输与春运节假日协调保障系统',
    url: 'https://zc.bjysfz.cn/admin/#/login',
    png: 'bjysfz'
}])
const openUrl = (url)=> {
    if(url) {
        window.open(url)
    } else {
        alert('该系统已停用')
    }
}

</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
    height: 100%;
    overflow: auto;
}

.top-bg {
    position: relative;
    height: 320px;
    background-image: url('@/assets/img/bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo {
    height: 120px;
    width: 512px;
    background-image: url('@/assets/img/logo_jt_202107.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
}

.bg-line {
    height: 20px;
    width: 100%;
    position: absolute;
    background-color: #f79663;
    bottom: 0px;
    box-shadow: 0px 0px 12px #fdc47a;
}

.project-list {
    /* margin-top: 10px; */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /* padding: 0px 8px; */
    padding-right: 8px;
    margin-bottom: 8px;
}

.project-item {
    margin-top: 8px;
    margin-left: 8px;
    height: 214px;
    display: flex;
    width: calc((100% - 66px) / 3);
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 6px;
    user-select: none;
    cursor: pointer;
}

.project-img {
    width: 130px;
    height: 100%;
    display: flex;
    justify-content: center;
}

.project-item:hover {
    box-shadow: 0px 0px 12px rgba(0, 0, 0, .12);
}

.project-item .project-content {
    width: 100%;
    margin-left: 8px;
}

.project-item .project-content .project-content_title {
    line-height: 32px;
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    color: #333;
}

.project-item .project-content .project-content_subtitle {
    line-height: 24px;
    font-size: 14px;
    color: #5b5b5b;
    height: calc(100% - 32px);
}

.text_overflow {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;
}
.foot {
    min-width: 60rem;
    overflow: hidden;
    height: 11rem;
    background-color: #bd1a2d;
}

.copy-right {
    min-width: 60rem;
    height: 4rem;
    background-color: #757575;
    color: #cecece;
    font-size: 0.8rem;
    line-height: 4rem;
    user-select: none;
}

.foot-content {
    width: 75rem;
    padding-left: 0;
    padding-right: 0;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    justify-content: space-between;
}

.foot-content span, .foot-content a {
    color: #cecece;
    font-size: 1rem;
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background-color: #99a9bf;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 5px;
  background-color: #d3dce6;
}
</style>